import React from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import { Tabs } from 'antd';
import useQueryParams from 'hooks/useQueryParams';
import IntegrationCampaignSpent from 'modules/network-accounts/components/IntegrationCampaignSpent';

const RevenueSourcesConfigDrawer = (props) => {
  const { searchParams } = useQueryParams();
  const { store_id } = searchParams;

  const items = [
    {
      key: 'ad_spent',
      label: 'Exclude Ads & Accounts',
      children: <IntegrationCampaignSpent />,
    },
  ];

  return (
    <AutomaticDrawer size='large' title='Revenue Sources Config' {...props}>
      <Tabs className='text-md font-semibold' defaultActiveKey='ad_spent' items={items} />
    </AutomaticDrawer>
  );
};

export default RevenueSourcesConfigDrawer;

RevenueSourcesConfigDrawer.requiredParams = {
  store_id: (p) => p,
  integration_type: (p) => p,
};
